module.exports = __webpack_public_path__ + "img/card4.bbc1466a.png";